import { render, staticRenderFns } from "./XalqaroHamkorlik.vue?vue&type=template&id=42ebcd25&scoped=true&"
import script from "./XalqaroHamkorlik.vue?vue&type=script&lang=js&"
export * from "./XalqaroHamkorlik.vue?vue&type=script&lang=js&"
import style0 from "./XalqaroHamkorlik.vue?vue&type=style&index=0&id=42ebcd25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ebcd25",
  null
  
)

export default component.exports